import { render, staticRenderFns } from "./sonnema-1860.vue?vue&type=template&id=f6bdea64&"
import script from "./sonnema-1860.vue?vue&type=script&lang=js&"
export * from "./sonnema-1860.vue?vue&type=script&lang=js&"
import style0 from "./sonnema-1860.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./sonnema-1860.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CaseIntro: require('/app/components/case/intro.vue').default,CaseContent: require('/app/components/case/content.vue').default,CaseList: require('/app/components/case/list.vue').default,CaseCta: require('/app/components/case/cta.vue').default,CaseRelated: require('/app/components/case/related.vue').default})
